(function(){
    "use strict";

    angular
        .module('elogbooksControllers')
        .controller(
            'ChangePartnershipController',
            function (
                siteCollection,
                serviceProviderResponse,
                partnershipsResponse,
                apiClient,
                $state,
                $rootScope,
                messenger,
                validationService,
                confirmationModal,
                $http,
                API_URL
            ) {
            var vm = this;
            vm.siteCollection = siteCollection;
            vm.partnershipsResponse = partnershipsResponse;
            vm.validationService = validationService;
            vm.loading = false;
            vm.grantAllActiveSites = grantAllActiveSites;
            vm.deactivateAllSites = deactivateAllSites;
            vm.deleteUnusedPartnerships = deleteUnusedPartnerships;

            function grantAllActiveSites() {
                $rootScope.skipDirtyCheck = true;
                var requestData = {
                    _links: {
                        site: []
                    },
                    activateAllPartnerships: '1'
                };

                angular.forEach(vm.siteCollection.sites, function(site) {
                    requestData._links.site.push(site._links.self);
                })

                apiClient
                    .create(serviceProviderResponse.getLink('partnerships'), requestData)
                    .then(function(response) {
                        if (response) {
                            $state.go('dashboard.admin.service-providers.list.details.partnerships', {}, { reload: true }).then(function() {
                                $rootScope.skipDirtyCheck = false;
                                messenger.success('PARTNERSHIPS_UPDATED');
                            });
                        }
                });
            }

            function deactivateAllSites() {
                $rootScope.skipDirtyCheck = true;
                var requestData = { deactivateAllPartnerships: '1' };

                apiClient
                    .update(serviceProviderResponse.getLink('partnerships'), requestData)
                    .then(function(response) {
                        if (response) {
                            $state.go('dashboard.admin.service-providers.list.details.partnerships', {}, { reload: true }).then(function() {
                                $rootScope.skipDirtyCheck = false;
                                messenger.success('PARTNERSHIPS_UPDATED');
                            });
                        }
                });
            }

            function deleteUnusedPartnerships() {
                return confirmationModal.open(
                    {
                        bodyMessage: 'WILL_DELETE_ALL_PARTNERSHIPS_FROM_SERVICE_PROVIDER',
                        primaryText: 'CONFIRM',
                        secondaryText: 'CANCEL'
                    }
                ).result.then(function(response) {
                    vm.loading = true;

                    if (response.result) {
                        $http.delete(API_URL + serviceProviderResponse.getLink('delete-unused-partnerships'), {
                            params: {}
                        }).then(function (response) {
                            if (response.status == 200) {
                                return $state.go('dashboard.admin.service-providers.list.details.partnerships').then(function() {
                                        $rootScope.skipDirtyCheck = false;
                                        messenger.success(response.data);
                                });
                            }

                            if (response.status == 204) {
                                return $state.go('dashboard.admin.service-providers.list.details.partnerships', {}, { reload: true }).then(function() {
                                    $rootScope.skipDirtyCheck = false;
                                    messenger.success('PARTNERSHIPS_UPDATED');
                                });
                            }

                            $state.go('dashboard.admin.service-providers.list.details.partnerships').then(function() {
                                $rootScope.skipDirtyCheck = false;
                                messenger.error('REQUEST_ERROR');
                            });
                        });
                    };
                });
            }
    });
})();
